import { ErrorBase } from "store/ErrorBase"


export class TimeoutError extends ErrorBase {
	constructor() {
		super()
	}
}
